module.exports = __webpack_public_path__ + "img/yqh2.e2323789.jpg";